(function () {
  function initGallery(root) {
    if (!root) return;
    var images = Array.from(root.querySelectorAll('[data-gallery-image]'));
    var thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.from(root.querySelectorAll('[data-gallery-dot]'));
    var index = 0;

    function show(i) {
      if (!images.length) return;
      index = (i + images.length) % images.length;
      images.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === index);
      });
      thumbs.forEach(function (thumb, idx) {
        var active = idx === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === index);
      });
    }

    function bindTriggers(nodes) {
      nodes.forEach(function (node) {
        node.addEventListener('click', function () {
          show(Number(node.dataset.index || 0));
        });
      });
    }

    bindTriggers(thumbs);
    bindTriggers(dots);
    show(0);
  }

  function initQuantity(form) {
    var input = form.querySelector('[data-qty-input]');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        input.value = String(Math.max(1, Number(input.value || 1) - 1));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = String(Number(input.value || 1) + 1);
      });
    }
  }

  function initVariants(form) {
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl || !form) return;

    var product = JSON.parse(jsonEl.textContent);
    var variantInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('.product-price__current');
    var compareEl = document.querySelector('.product-price__compare');
    var saveBadge = document.querySelector('[data-save-badge]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var submitText = form.querySelector('[data-add-to-cart-text]');
    var stickyPrice = document.querySelector('.sticky-cart__price');
    var currentId = Number(variantInput.value);
    var currentVariant = product.variants.find(function (v) { return v.id === currentId; }) || product.variants[0];
    var selectedOptions = {};

    product.options.forEach(function (name, idx) {
      var key = 'option' + (idx + 1);
      selectedOptions[name] = currentVariant[key];
    });

    function findVariant() {
      return product.variants.find(function (variant) {
        return product.options.every(function (name, idx) {
          var key = 'option' + (idx + 1);
          return variant[key] === selectedOptions[name];
        });
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
    }

    var priceRoot = document.querySelector('[data-product-price]');
    var priceComingSoon = priceRoot && priceRoot.getAttribute('data-price-coming-soon') === 'true';
    var comingSoonLabel = (priceRoot && priceRoot.getAttribute('data-coming-soon-label')) || 'Coming Soon';

    function setAddToCartLabel(variant) {
      if (!submitText) return;
      if (!variant.available) {
        submitText.textContent = 'Sold out';
        return;
      }
      submitText.textContent = priceComingSoon
        ? 'Add to Cart'
        : 'Add to Cart — ' + formatMoney(variant.price);
    }

    function updateVariantUI() {
      var variant = findVariant();
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (priceComingSoon) {
        if (priceEl) priceEl.textContent = comingSoonLabel;
        if (stickyPrice) stickyPrice.textContent = comingSoonLabel;
        if (compareEl) compareEl.hidden = true;
        if (saveBadge) saveBadge.hidden = true;
      } else {
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (saveBadge) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            saveBadge.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
            saveBadge.hidden = false;
          } else {
            saveBadge.hidden = true;
          }
        }
      }

      if (submitBtn) submitBtn.disabled = !variant.available;
      setAddToCartLabel(variant);
    }

    form.querySelectorAll('[data-option-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var name = button.dataset.optionName;
        selectedOptions[name] = button.dataset.optionValue;

        form.querySelectorAll('[data-option-button][data-option-name="' + name + '"]').forEach(function (el) {
          el.classList.toggle('is-selected', el === button);
        });

        var label = document.querySelector('[data-option-label="' + name.toLowerCase().replace(/\s+/g, '-') + '"]');
        if (label) label.textContent = button.dataset.optionValue;

        updateVariantUI();
      });
    });

    updateVariantUI();
  }

  function initAddToCartFeedback(form) {
    var submitText = form.querySelector('[data-add-to-cart-text]');
    form.addEventListener('submit', function () {
      if (!submitText) return;
      var previous = submitText.textContent;
      submitText.textContent = 'Added to cart';
      setTimeout(function () {
        submitText.textContent = previous;
      }, 2000);
    });
  }

  function initStickyCart(form) {
    var stickyBtn = document.querySelector('[data-sticky-add-to-cart]');
    if (!stickyBtn || !form) return;
    stickyBtn.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery(document.querySelector('[data-product-gallery]'));
    var form = document.querySelector('.roastery .product-form');
    if (form) {
      initQuantity(form);
      initVariants(form);
      initAddToCartFeedback(form);
      initStickyCart(form);
    }
  });
})();
